import * as Styled from './styled';
import { Props } from './types';
import withField from '~hocs/withField';

export function Input({ width, variant, ...props }: Props) {
  const handleInput = (event) => {
    if (props.type === 'number') {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
    }
  };

  return (
    <Styled.Input
      {...props}
      $width={width}
      $variant={variant}
      onInput={handleInput}
    />
  );
}

Input.defaultProps = {
  placeholder: ' ',
  autoComplete: 'off',
  width: '100%',
};

export default withField(Input);
